<template>
  <div :class="['main-navbar', 'bg-white', stickyTop ? 'sticky-top' : '']">
    <d-navbar type="light" class="align-items-stretch flex-md-nowrap p-0">
      <navbar-search />
        <d-button class="mr-3" @click.prevent="$eventHub.$emit('show-pay-schedules-modal')" theme="success" v-if="this.getUser.is_admin !== 2"><i class="material-icons mr-1">add</i> Dodaj wpłaty
            do wielu umów
        </d-button>
        <d-button class="mr-3" @click.prevent="$router.push({ name: 'schedule-new' })"  v-if="this.getUser.is_admin !== 2"><i class="material-icons mr-1">calendar_today</i> Generator harmonogramu</d-button>
      <navbar-nav />
      <navbar-toggle />
    </d-navbar>
  </div>
</template>

<script>
import NavbarSearch from './NavbarSearch.vue';
import NavbarNav from './NavbarNav.vue';
import NavbarToggle from './NavbarToggle.vue';
import {mapGetters} from "vuex";

export default {
  components: {
    NavbarSearch,
    NavbarNav,
    NavbarToggle,
  },
  props: {
    /**
       * Whether the main navbar should be sticky, or not.
       */
    stickyTop: {
      type: Boolean,
      default: true,
    },
  },
  computed:{
    ...mapGetters([
        'getUser'
    ])
  },
};
</script>

<style lang="scss" scoped>
  .btn{
    align-self: center;
    white-space: nowrap;
  }
</style>

<style lang="scss">
.main-navbar {
  .dropdown-menu {
    display: block;
  }
}

</style>
